<template>
    <div class="investor-biodata">
        <DrawerInvestorProfile ref="drawer_investor_profile" />
        <b-card no-body>
            <b-card-header class="border-0 p-3">
                <b-row align-v="center">
                    <b-col cols="10">
                        <h3 class="mb-0">
                            Esther Howard
                        </h3>
                    </b-col>
                    <b-col cols="2">
                        <el-button @click="$refs.drawer_investor_profile.viewInvestorProfile()" class="float-right py-0 text-primary" type="text">Edit</el-button>
                    </b-col>
                </b-row>
            </b-card-header>

            <b-container>
                <b-row class="mb-2" align-v="center" no-gutters>
                    <b-col cols="auto" class="d-flex align-items-center border rounded px-2 py-1">
                         <el-dropdown trigger="click" style="cursor: pointer;">
                            <p class="text-muted">Status</p>
                            <p class="el-dropdown-link top-line">
                                <span class="d-inline-block text-truncate" 
                                    style="max-width: 150px; overflow: unset;"
                                    :class="getStatusColor('In-Progressive')"
                                >{{ 'In-Progressive' }}</span>
                                <i class="el-icon-caret-bottom el-icon--right"></i>
                            </p>
                            <el-dropdown-menu slot="dropdown">
                                <div style="max-height: 300px;overflow-y: auto;">
                                    <el-dropdown-item v-for="(status, index) in statusList" :key="index" >{{ status.name }}</el-dropdown-item>
                                </div>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </b-col>
                    <b-col cols="auto">
                        <b-button variant="primary" class="p-1 m-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="20" viewBox="0 0 24 24" class="mx-0">
                                <path fill="currentColor" fill-rule="evenodd"
                                d="M2 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-3.586l-3.707 3.707A1 1 0 0 1 6 17v-3H5a3 3 0 0 1-3-3V5zm20 4v6c0 1-.6 3-3 3h-1v3c0 .333-.2 1-1 1-.203 0-.368-.043-.5-.113L12.613 18H9l3-3h3c1.333 0 4-.8 4-4V6c1 0 3 .6 3 3z"
                                clip-rule="evenodd" />
                            </svg>
                        </b-button>
                    </b-col>
                </b-row>
                <b-row class="my-3">
                    <b-col cols="12">
                        <div class="d-flex align-items-center mb-2">
                            <small class="pr-3 font-weight-bolder text-gray">ID</small>
                            <p>3619</p>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <b-icon icon="person-fill" class="mr-3" variant="gray"></b-icon>
                            <p>31 years old</p>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <b-icon icon="telephone-fill" class="mr-3" variant="gray"></b-icon>
                            <p>013-234 5678</p>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <b-icon icon="envelope-fill" class="mr-3" variant="gray"></b-icon>
                            <p>jojo85@mail.com</p>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" class="mr-3" width="14" height="14" viewBox="0 0 512 512"><path fill="#A4B0C0" d="m243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224H64v196.3c-.6.3-1.2.7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512h448c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384v192h-40V224h-64v192h-48V224h-64v192h-40V224zM256 64a32 32 0 1 1 0 64a32 32 0 1 1 0-64z"/></svg>
                            <p>RHB Bank</p>
                            <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <circle cx="2.5" cy="3" r="2.5" fill="#A4B0C0"/>
                            </svg>
                            <p>1123 456 7899</p>
                        </div>
                    </b-col>
                    <b-col>
                        <el-button class="float-left py-0 text-primary" type="text">
                        <p class="text-primary">
                            View More <b-icon icon="chevron-right"></b-icon>
                        </p>
                        </el-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-card>
    </div>
</template>
<script>
import { Button, Dropdown, DropdownItem, DropdownMenu } from 'element-ui'
import DrawerInvestorProfile from '@/views/FundsMgmtInvestors/InvestorModals/DrawerInvestorProfile'

export default {
    components: {
        DrawerInvestorProfile,
        [Button.name]: Button,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
    },
    data() {
        return {
            statusList: [
                { name: 'In-Progressive', value: 'in-progressive' },
                { name: 'Withdrawer', value: 'withdrawer' },
                { name: 'Completed', value: 'completed' },
            ],
        }
    },
    methods: {
        getStatusColor(status) {
            switch (status) {
              case 'In-Progressive':
                  return 'text-warning'; // Change to green color class
                  break;
              case 'Withdrawer':
                  return 'text-danger'; // Change to yellow color class
                  break;
              case 'Completed':
                  return 'text-success'; // Change to red color class
                  break;
              default:
                  return 'text-dark'; // Change to dark color class
                  break;
            }
        }
    }
}
</script>